import React from 'react';
import RecoverPassword from '../components/RecoverPassword/RecoverPassword';

const RecoverPasswordPage = () => {

  return (
      <div>
        <RecoverPassword />
      </div>
    
  );
};

export default RecoverPasswordPage;


/** WEBPACK FOOTER **
 ** ./src/containers/RecoverPasswordPage.js
 **/